export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6562.bb723012.jpg";